export const DEVICE_TYPE = {
    DESKTOP: 0,
    MOBILE: 1,
    APP: 2
}

export const RESOURCE_TYPE = {
    SLIDER: 1,
    BANNER: 2,
    PRODUCT_SLIDER: 3,
    RIBBON: 7,
    BRAND_LOGO: 9
}

export const PAGE_CATEGORY = {
    MONO_LINE: 1,
    MONO_BRAND: 2,
    MULTI_COMPANY: 3,
    EDITORIAL: 4,
    PROMOTION: 5,
    OTHERS: 6,
    BRAND_LOGO: 7,
    MONO_COMPANY: 8
}

export const PAGE_PRODUCT_TYPE = {
    FRAGRANCES: 1,
    NON_FRAGRANCES: 2,
    MIX: 3,
    EDITORIAL_CONTENT: 4,
    MAKE_UP: 5,
    COSMETIC: 6,
    OTHER_BEAUTY: 7
}

export const TAGS = {
    PROMOCODE: 1,
    DISCOUNT: 2,
    GWP: 3
}